<template>
  <div class="box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TopBox",
};
</script>

<style scoped lang="scss">
.box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>
